/* ================================================================ */
// DATA REDUCER | Data/index.js
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
//import update from "react-addons-update";
import update from 'immutability-helper';
import * as DataActions from '../../actions/Data';
/* ========================================== */
// Reducer
/* ========================================== */
export default function reducer(
    state = {
        globe: {
            uuid: 'demo',
            title: '',
            config: {
                mobile: null,
                desktop: null,
                navigation: {
                    type: 'inline',
                    align: 'left',
                    header: {logo: '/assets/myglobe.png'}
                }
            }
        },
        // Loading State
        loading: {
            globe: true,
            datasets: true,
            pages: true,
            stories: true,
            panels: true,
            states: true,
            layers: true,
            media:false,
        },
        // Datasets Data
        datasets: {
            byId: [],
            byHash: {}
        },
        // Page Data
        pages: {
            byId: [],
            byHash: {}
        },
        // Map Data
        layers: {
            byId: [],
            byHash: {}
        },
        states: {
            byId: [],
            byHash: {}
        },
        // Story Data
        stories: {
            byId: [],
            byHash: {}
        },
        panels: {
            byId: [],
            byHash: {}
        },
        uploads: {
            code: 200,
            name:'',
            error:undefined
        },
    }, action) {
    switch (action.type) {

    /* ======================== */
    // FETCH ALL
    /* ======================== */
    case DataActions.FETCH_INIT: {
        return {
            ...state,
            loading: {
                globe: true,
                pages: true,
                stories: true,
                panels: true,
                states: true,
                layers: true,
                media:false
            }
        };
    }
    /* ======================== */
    // GLOBE CONFIG
    /* ======================== */
    case DataActions.FETCH_GLOBE: { return {...state, loading: {...state.loading, globe: true}}; }
    case DataActions.FETCH_GLOBE_FAILURE: { return {...state, error: action.error, loading: {...state.loading, globe: false}}; }
    case DataActions.FETCH_GLOBE_SUCCESS: { return {...state, globe: action.payload, loading: {...state.loading, globe: false}}; }
    /* ======================== */
    // DATA - DATASETS
    /* ======================== */
    case DataActions.Datasets.FETCH_DATASETS: { return {...state, loading: {...state.loading, datasets: true}}; }
    case DataActions.Datasets.FETCH_DATASETS_FAILURE: { return {...state, error: action.error, loading: {...state.loading, datasets: false}}; }
    case DataActions.Datasets.FETCH_DATASETS_SUCCESS: { return {...state, loading: {...state.loading, datasets: false}}; }
    case DataActions.Datasets.UPDATE_DATASET: { return {...state, loading: {...state.loading, datasets: true}}; }
    case DataActions.Datasets.UPDATE_DATASET_FAILURE: { return {...state, error: action.error, loading: {...state.loading, datasets: false}}; }
    case DataActions.Datasets.UPDATE_DATASET_SUCCESS: { return {...state, loading: {...state.loading, datasets: false}}; }
    case DataActions.Datasets.UPLOAD_MEDIA: { return {...state, loading: {...state.loading, media: true}, uploads: {code:action.payload,name:'',error:undefined}}; };
    case DataActions.Datasets.UPLOAD_MEDIA_SUCCESS: { return {...state, loading: {...state.loading, media: false}, uploads: {code:200,name:action.payload,error:undefined}}; };
    case DataActions.Datasets.UPLOAD_MEDIA_FAILURE: { return {...state,  loading: {...state.loading, media: false}, uploads: {code:action.payload,name:'',error:action.error}}; };

    // case DataActions.Datasets.UPDATE_DODGY_VISLAYERS: { 
    //     console.log("~~~~",action.payload); 
    //     var byId = []; action.payload.forEach(x=>{byId[x.Id]=x} ); 
    //     return {...state, 
    //     loading: {...state.loading, layers: false},
    //     layers: {...state.layers, 
    //         byId: [...state.layers.byId, byId]
    //     }
    // }; }
    case DataActions.Content.UPDATE_DODGY_VISLAYERS: {
        let layers = [];
        action.payload.forEach(l=>layers[l.Id] = l);
        return {
            ...state,
            layers: {                
                byId: layers
            },
            loading: {
                ...state.loading,
                layers: false
            }
        }; }

    /* ======================== */
    // MAPPING - LAYERS
    /* ======================== */
    case DataActions.Mapping.FETCH_LAYERS: { return {...state, loading: {...state.loading, layers: true}}; }
    case DataActions.Mapping.FETCH_LAYERS_FAILURE: { return {...state, error: action.error, loading: {...state.loading, layers: false}}; }
    case DataActions.Mapping.FETCH_LAYERS_SUCCESS: { return {...state, loading: {...state.loading, layers: false}}; }    
    /* ======================== */
    // MAPPING - STATES
    /* ======================== */
    case DataActions.Mapping.FETCH_STATES: { return {...state, loading: {...state.loading, states: true}}; }
    case DataActions.Mapping.FETCH_STATES_FAILURE: { return {...state, error: action.error, loading: {...state.loading, states: false}}; }
    case DataActions.Mapping.FETCH_STATES_SUCCESS: { return {...state, loading: {...state.loading, states: false}}; }
    case DataActions.Mapping.UPDATE_VISSTATES: { return {...state, loading: {...state.loading, states: false}}; }
    case DataActions.Mapping.UPDATE_VISSTATES_SUCCESS: { return {...state, loading: {...state.loading, states: false}}; }
    case DataActions.Mapping.UPDATE_VISSTATES_FAILURE: { return {...state, loading: {...state.loading, states: false}}; }
    /* ======================== */
    // CONTENT - PAGES
    /* ======================== */
    case DataActions.Content.FETCH_PAGES: { return {...state, loading: {...state.loading, pages: true}}; }
    case DataActions.Content.FETCH_PAGES_FAILURE: { return {...state, error: action.error, loading: {...state.loading, pages: false}}; }
    case DataActions.Content.FETCH_PAGES_SUCCESS: { return {...state, loading: {...state.loading, pages: false}}; }
    /* ======================== */
    // CONTENT - STORIES
    /* ======================== */
    case DataActions.Content.FETCH_STORIES: { return {...state, loading: {...state.loading, stories: true}}; }
    case DataActions.Content.FETCH_STORIES_FAILURE: { return {...state, error: action.error, loading: {...state.loading, stories: false}}; }
    case DataActions.Content.FETCH_STORIES_SUCCESS: { return {...state, loading: {...state.loading, stories: false}}; }
    case DataActions.Content.CREATE_STORY: { return {...state, loading: {...state.loading, stories: true}}; }
    case DataActions.Content.CREATE_STORY_SUCCESS: { 
        return {
            ...state,
            stories: {
                byHash: {
                    ...state.stories.byHash,
                    [action.payload.uuid]: {
                        ...action.payload
                    }
                },
                byId: [...state.stories.byId, action.stories.uuid]
            },
            loading: {
                ...state.loading,
                stories: false
            }
        }; 
    }
    case DataActions.Content.UPDATE_STORY: { return {...state, loading: {...state.loading, stories: true}}; }
    case DataActions.Content.UPDATE_STORY_SUCCESS: {
        console.log(action.payload);
        return {
            ...state,
            stories: {
                ...state.stories,
                byHash: {
                    ...state.stories.byHash,
                    [action.payload.uuid]: {
                        ...state.stories.byHash[action.payload.uuid],
                        ...action.payload
                    }
                }
            },
            loading: {
                ...state.loading,
                stories: false
            }
        };
    }
    /* ======================== */
    // CONTENT - PANELS
    /* ======================== */
    case DataActions.Content.FETCH_PANELS: { return {...state, loading: {...state.loading, panels: true}}; }
    case DataActions.Content.FETCH_PANELS_FAILURE: { return {...state, error: action.error }; }
    case DataActions.Content.FETCH_PANELS_SUCCESS: { return {...state, loading: {...state.loading, panels: false}}; }
    case DataActions.Content.CREATE_PANEL: { return {...state, loading: {...state.loading, panels: true}}; }
    case DataActions.Content.CREATE_PANEL_SUCCESS: {
        return {
            ...state,
            panels: {
                byHash: {
                    ...state.panels.byHash,
                    [action.payload.uuid]: {
                        ...action.payload
                    }
                },
                byId: [...state.panels.byId, action.payload.uuid]
            },
            loading: {
                ...state.loading,
                panels: false
            }
        }; }
    case DataActions.Content.UPDATE_PANEL: { return {...state, loading: {...state.loading, panels: true}}; }
    case DataActions.Content.UPDATE_PANEL_SUCCESS: {
        console.log(action.payload);
        return {
            ...state,
            panels: {
                ...state.panels,
                byHash: {
                    ...state.panels.byHash,
                    [action.payload.uuid]: {
                        ...state.panels.byHash[action.payload.uuid],
                        ...action.payload
                    }
                }
            },
            loading: {
                ...state.loading,
                panels: false
            }
        };
    }
    case DataActions.Content.UPDATE_PANEL_ORDER: { return {...state, loading: {...state.loading, panels: true}}; }
    case DataActions.Content.UPDATE_PANEL_ORDER_FAILURE: { return {...state, error: action.payload, loading: {...state.loading, panels: false}}; }
    case DataActions.Content.UPDATE_PANEL_ORDER_SUCCESS: {
        let newPanelHash = {...state.panels.byHash};
        action.payload.forEach(updatedPanel=>newPanelHash[updatedPanel.uuid] = {...newPanelHash[updatedPanel.uuid], ...updatedPanel});
        return {
            ...state,
            panels: {
                ...state.panels,
                byHash: newPanelHash
            },
            loading: {
                ...state.loading,
                panels: false
            }
        };
    }
    case DataActions.Content.DELETE_PANEL: { return {...state, loading: {...state.loading, panels: true}}; }
    case DataActions.Content.DELETE_PANEL_FAILURE: { return {...state, error: action.payload, loading: {...state.loading, panels: false}}; }
    case DataActions.Content.DELETE_PANEL_SUCCESS: { 
        //TODO: move this to generic data operator
        // Remove panel by id from both duplicated ids array and hashmap
        let panelId = action.payload;
        let newPanelIds = [...state.panels.byId];
        let newPanelHash = {...state.panels.byHash};
        let panelIdIndex = newPanelIds.indexOf(panelId);
        // Remove panelId from ids array if exists
        if(panelIdIndex > -1) {
            newPanelIds.splice(panelIdIndex, 1);
        }
        // Remove panel from panel hash if exists
        if (Object.prototype.hasOwnProperty.call(newPanelHash, panelId)) {            
            delete newPanelHash[panelId];
        }                    
        return {
            ...state,
            panels: {
                byId: newPanelIds,
                byHash: newPanelHash
            },
            loading: {
                ...state.loading, 
                panels: false
            }
        }; 
    }
    case DataActions.Content.PANEL_ACTION_FAILURE: { return {...state, error: action.error }; }
    /* ======================== */
    // GENERIC - ADD DATA
    /* ======================== */
    case DataActions.ADD_DATA_ITEM: {
        const {datasetID, itemID, payload} = action;
        // Get Dataset from state
        const dataset = state[datasetID];
        // Do not override existing data items (use UPDATE_DATA_ITEM)
        //if(dataset.byHash.hasOwnProperty(itemID))
        if(Object.prototype.hasOwnProperty.call(dataset.byHash, itemID))
            return state;
        const updatedDataset = update(state[datasetID], {
            byId: {$set: [
                ...state[datasetID].byId,
                itemID
            ]},
            byHash: {$set: {
                ...state[datasetID].byHash,
                [itemID]: payload
            }}
        });
        return {...state, [datasetID]: updatedDataset};
    }
    case DataActions.ADD_DATA_ARRAY: {
        const {datasetID, payload} = action;
        // Process payload array
        var hashes = {};
        const ids = payload.map(row=>{
            const {id, data} = row;
            hashes[id] = data;
            return id;
        });
        const updatedDataset = update(state[datasetID], {
            byId: {$set: [
                ...state[datasetID].byId,
                ...ids
            ]},
            byHash: {$set: {
                ...state[datasetID].byHash,
                ...hashes
            }}
        });
        return {...state, [datasetID]: updatedDataset};
    }
    case DataActions.ADD_DATA_HASHMAP: {
        const {datasetID, payload} = action;
        // Process payload array
        const ids = Object.keys(payload);
        const updatedDataset = update(state[datasetID], {
            byId: {$set: [
                ...state[datasetID].byId,
                ...ids
            ]},
            byHash: {$set: {
                ...state[datasetID].byHash,
                ...payload
            }}
        });
        return {...state, [datasetID]: updatedDataset};
    }
    default: { return state; }
    }
}